import { render, staticRenderFns } from "./DiagnosticHypothesisComponent.vue?vue&type=template&id=3f798943&"
import script from "./DiagnosticHypothesisComponent.vue?vue&type=script&lang=js&"
export * from "./DiagnosticHypothesisComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports